<template>
  <bk-page v-if="accessToken" class="languageVerifyPage" :navBarInfo="navBarInfo">
    <bk-view class="view-content">
      <bk-view v-if="errDataList && errDataList.length > 0" class="view-table">
        <bk-view class="view-header">
          <bk-view class="view-headerItem overflowText" :class="item.key" v-for="item in tableItems"
                   :key="item.langCode" v-bind="item">
            <bk-view>{{ item.label }}</bk-view>
          </bk-view>
        </bk-view>

        <bk-view class="view-list">
          <bk-view class="view-listItem" v-for="(item, index) in errDataList" :key="index">
            <bk-view v-for="keyObj in tableItems" :key="keyObj.key" :class="keyObj.key" v-bind="keyObj">

              <bk-view v-if="!keyObj.langFlag">
                <bk-view v-if="keyObj.switchFlag" :style="{textAlign: 'center'}">
                  <bk-switch v-model:value="item[keyObj.key]" @change="editItemChange(item, keyObj)"></bk-switch>
                </bk-view>
                <bk-view v-if="keyObj.textFlag">{{ item[keyObj.key] || '-' }}</bk-view>
              </bk-view>

              <bk-view v-if="keyObj.langFlag" class="view-langItem">
                <bk-view class="view-online">
                  <bk-view>{{ item[keyObj.key] ?? '空缺' }}</bk-view>
                </bk-view>
                <bk-view class="view-line"></bk-view>
                <bk-view
                  class="view-local"
                  :class="(item[keyObj.key] ?? '空缺') !== (item?.['localObj']?.[keyObj.key] ?? '空缺') ? 'isDff':''">
                  <bk-view>{{ item?.['localObj']?.[keyObj.key] ?? '空缺' }}</bk-view>
                </bk-view>
              </bk-view>
            </bk-view>
          </bk-view>
        </bk-view>
      </bk-view>
      <bk-view v-else class="view-loading">
        {{ errDataList ? '暂无差异数据' : '加载中' }}
      </bk-view>
    </bk-view>
  </bk-page>
</template>

<script>

	import {baseReq} from '@/reqService/index';
	import BkView from '@/components/bk-base/bk-view/bk-view.vue';
	import BkPage from '@/components/bk-base/bk-page/bk-page.vue';
	import BkSwitch from '@/components/bk-base/bk-switch/bk-switch.vue';

	export default {
		name: 'language',
		components: {BkSwitch, BkPage, BkView},
		computed: {
			tableItems () {

				return [
					{
						label: '序号',
						key: 'index',
						textFlag: true,
					},
					{
						label: 'LangCode',
						key: 'langCode',
						textFlag: true,
					},
					{
						label: 'English',
						key: 'text_en',
						langFlag: true,
						bottomFlag: true,
						style: 'flex: 2',
					},
					{
						label: '简体',
						key: 'text_ch',
						langFlag: true,
						bottomFlag: true,
						style: 'flex: 2',
					},
					{
						label: '繁体',
						key: 'text_tw',
						langFlag: true,
						bottomFlag: true,
						style: 'flex: 2',
					},
				];
			},
		},
		data () {
			return {
				navBarInfo: {
					backFlag: true,
					title: 'MaSe本地语言校对'
				},

				dataList: undefined,

				accessToken: this.$bk_getAccessToken(),
				errDataList: undefined,


			};
		},
		async mounted () {

			this.requestPostVerifyLocationLanguage();
		},
		methods: {

			async requestPostVerifyLocationLanguage () {

				let parame = {
					type: 'Mase_Clients',
					list: []
				};

				let dic = window.$bk_langsInfo['lang_en'];
				let chDic = window.$bk_langsInfo['lang_ch'];
				let twDic = window.$bk_langsInfo['lang_tw'];

				console.error('list:::', dic);

				for (let key in dic) {

					parame.list.push({
						langCode: key,
						text_en: (dic[key] || '').trim(),
						text_ch: (chDic[key] || '').trim(),
						text_tw: (twDic[key] || '').trim(),
					});
				}

				let res = await baseReq.requestLanguageVerify(this, parame).catch(() => {
				});

				bkLog.log('RES___:', res);

				(res || []).forEach((obj, index) => {
					const target = (parame.list || []).find((item) => {
						return item.langCode === obj.langCode;
					});
					if (target) {
						obj.localObj = target;
					}
					obj.index = index + 1;
				});

				this.errDataList = res || [];
			}
		}
	};
</script>

<style lang="less">

.languageVerifyPage {
  min-height: 100vh;
  padding-top: 64px;
  background: #f4f4f4;

  .view-loading {
    text-align: center;
    line-height: 50vh;
    font-size: @font-title;
  }

  .view-keyword {
    display: inline-block;

    > .bk-view {
      display: inline-block;
      text-align: left;
      margin-right: 12px;
      min-width: 180px;
      vertical-align: top;
    }
  }

  .view-btns {
    display: inline-block;

    > .bk-button {
      margin-right: 12px;
      height: 40px;
      width: 112px;
      padding: 0;

      &:last-child {
        margin-right: 0;
      }
    }
  }


  .bk-navBar {
    background: @color-bc-def;
  }

  .view-content {
    padding: 4px;
    height: 100%;

    .view-table {
      background: #fff;
      height: calc(100% - 52px);

      > .view-header {
        display: flex;
        background: #f8f8f8;

        > .bk-view {
          flex: 1;
          font-size: @font-def;
          .fontBloder();
          padding: 12px 0 12px 12px;

          &.check {
            cursor: pointer;

            .img-select {
              width: 18px;
              height: 18px;
              margin-right: 5px;
              vertical-align: middle;
            }
          }
        }
      }

      > .view-list {
        overflow-y: auto;
        height: calc(100% - 44px);

        > .view-loading {
          height: 100%;
        }

        > .view-listItem {
          display: flex;
          border-bottom: .5px solid rgba(220, 220, 220, .8);

          > .bk-view {
            position: relative;
            flex: 1;
            font-size: @font-def;
            padding: 12px;
            border-left: .5px solid rgba(220, 220, 220, .8);
            overflow-wrap: anywhere;
            .fontBloder();

            .view-langItem {
              .view-online {
                padding-bottom: 10px;
              }

              .view-line {
                width: 100%;
                height: 1px;
                border-bottom: 1px dashed #cccccc;
              }

              .view-local {
                padding-top: 10px;

                &.isDff {
                  color: @color-red;
                }
              }
            }
          }
        }
      }
    }

    .view-bottom {
      display: flex;
      padding-top: 12px;

      > .view-left {
        padding-left: 24px;
        flex: 1;
      }
    }
  }

  .popup-edit {
    text-align: center;

    .view-title {
      padding: 20px 0;
    }

    .view-value {
      padding: 0 20px;

      > .ant-input {
        height: 80px;
        line-height: 20px;
        font-size: 14px;
      }

      > .view-tip {
        padding: 10px 0;
        font-size: 13px;
        color: @color-text-tip;
      }
    }

    .view-btns {
      margin-top: 12px;

      > .bk-button {
        width: 100px;
        height: 40px;

        &:first-child {
          background: #fff;
          color: var(--color-main);
        }
      }
    }
  }
}
</style>